




















































import { Component, Prop } from 'vue-property-decorator';
import Vue from '@/vue.type';
import ProjectAvatarComponent from '@/shared/avatars/project/project-avatar.component.vue';
import ProjectAvatar from '@/shared/avatars/project/project-avatar.class';
import ProjectWithMembers from '@/domain/project/project-with-members.entity';
import AuthorityStore from '@/domain/security/authority.store';
import Authority from '@/domain/security/authority.entity';

@Component({
  components: {
    ProjectAvatarComponent,
  },
})
export default class MyProjects extends Vue {
  @Prop({
    required: false,
    default: [],
  })
  private projects?: ProjectWithMembers[];

  @Prop({
    required: false,
    default: [],
  })
  private icons?: any[];

  private authorities: Authority = new Authority([]);

  created() {
    this.checkAutorities();
  }

  private navigate(name: string, path: string): void {
    if (name) {
      this.$router.push(`/${name}/${path}`);
    }
  }

  private clickIcon(project: ProjectWithMembers, icon: any): void {
    if (icon.path) this.navigate(project.name, icon.path);
    if (icon.title === 'editProject') this.$emit('openEditProjectModal', project);
  }

  private checkAutorities() {
    AuthorityStore.fetchedAuthority()
      .then((resp: Authority) => this.authorities = resp);
  }

  get getFilteredIcons(): string[] {
    return this.icons!!.filter((el: any) => {
      if (el.authorities.length > 0) {
        return this.authorities.hasAuthorities(el.authorities);
      }
      return true;
    });
  }
}
